<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                          <ValidationObserver v-slot="{ handleSubmit }" ref="form">
                            <form @submit.prevent="handleSubmit">
                              <div class="p-8">
                                  <div class="vx-card__title mb-8">
                                      <h4 class="mb-4">{{ $t('views.user.reset-password.title') }}</h4>
                                      <p>{{ $t('views.user.reset-password.subtitle') }}</p>
                                  </div>
                                    <div class="mb-6">
                                      <validation-provider :name="$t('views.user.reset-password.newPassword')" :rules="{ required: true, min: 8 }" v-slot="{ errors }">
                                        <vs-input type="password" :label-placeholder="$t('views.user.reset-password.newPassword')" v-model="form.newPassword" class="w-full" />
                                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                                      </validation-provider>
                                    </div>
                                    <div class="mb-8">
                                      <validation-provider :name="$t('views.user.reset-password.confirmPassword')" :rules="{required: true, confirmPassword: { password: form.newPassword }}" v-slot="{ errors }">
                                        <vs-input type="password" :label-placeholder="$t('views.user.reset-password.confirmPassword')" v-model="form.confirmPassword" class="w-full" />
                                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                                      </validation-provider>
                                    </div>
                                  <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                                      <vs-button type="border" to="/user/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">{{ $t('views.user.reset-password.btnGoback') }}</vs-button>
                                      <vs-button class="w-full sm:w-auto" @click="submit()">{{ $t('views.user.reset-password.btnSubmit') }}</vs-button>
                                  </div>
                              </div>
                            </form>
                          </ValidationObserver>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { ValidationProvider } from 'vee-validate'

export default {
  data () {
    return {
      form:{
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    ...mapState(['currentUser', 'status'])
  },
  methods: {
    ...mapActions(['otpReset']),
    submit () {
      const vm = this
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }
        this.otpReset({
          form: {
            newPassword: vm.form.newPassword
          },
          vm
        })
      })
    }
  },
  components: {
    ValidationProvider
  }
}
</script>
